<template>
  <div v-if="enterpriseIdss">
  <a-modal v-model="requirementsEnterpriseible" footer="'" title="企业要求" width="85%" >
    <div style="margin-top: 40px;" :class="[!detailEdit ? 'disEvents':'disEvents2']">
      <a-tabs type="card" @change="callbackSet">
        <a-tab-pane v-if="detailOther" tab="下单要求" key="1">
          <a-table
          size="default"
          ref="table"
          :pagination="pagination"
          :columns="demandColumns"
          :dataSource="createOrderDemand">
          <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
          <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px"  :disabled="true">配置</a-button>
          <span v-if="record.editable">
            <!--{{record.editable}}-->
          <a-button type="primary" style="margin-right: 10px" @click="() => demandSubmit(record.key, 'createOrderDemand')"  :disabled="true">保存</a-button>
          <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'createOrderDemand')" >
          <a-button type="primary" style="margin-right: 10px" :disabled="true">取消</a-button>
          </a-popconfirm>
          </span>
          <span v-else>
            <!--{{record.editable}}-->
          <a-button  @click="() => demandEdit(record.key, 'createOrderDemand')" type="primary" style="margin-right: 10px" :disabled="true">编辑</a-button>
          </span>
          <a-button type="primary" v-if="record.disabledFlag==0" @click="disableDemand(record.demandId)" style="margin-right: 10px" :disabled="true">禁用</a-button>
          <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px" :disabled="true">启用</a-button>
          <a-button type="primary"  @click="deleteDemand(record.demandId)" style="margin-right: 10px" :disabled="true">删除</a-button>
          </template>
          <template slot="demandContent" slot-scope="text, record, index">
          <div>
          <a-input :disabled="true"
          v-if="record.editable"
          style="margin: -5px 0"
          :value="text"
          @change="e => demandChange(e.target.value, record.key, 'createOrderDemand')" />
          <template v-else>
          {{ text }}
          </template>
          </div>
          </template>
          </a-table>
          <template>
          <a-textarea v-model.trim="createOrderDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px" />
          <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('create_order_demand')" :disabled="true">提交</a-button>
          </template>
          <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 },wrapperCol: { span: 15 } }">
          <div class="clearfix">
          <a-upload :disabled="true"
          :action="uploadUrlb"
          list-type="picture-card"
          :file-list="fileList"
          :headers="headers"
          @preview="handlePreview"
          @change="handleChange"
          >
          <div>
          <a-icon type="plus" />
          <div class="ant-upload-text">上传</div>
          </div>
          </a-upload>
          <a-modal  :disabled="true"  :visible="previewVisible" :footer="null" @cancel="handleCancel">
          <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
          </div>
          <a-col :span="24" style="display: flex;justify-content: center;">
          <a-button type="primary" @click="picSubmit('create_order_demand')" html-type="submit" :disabled="true">
          提交
          </a-button>
          </a-col>
          </a-form-item>
        </a-tab-pane>
        <a-tab-pane v-if="detailOther" tab="派单要求"  key="2">
          <a-table
          size="default"
          ref="table"
          :pagination="pagination"
          :columns="demandColumns"
          :dataSource="dispatchOrderDemand">
          <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
          <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px" :disabled="true">配置</a-button>
          <span v-if="record.editable">
          <a-button type="primary" style="margin-right: 10px" @click="() => demandSubmit(record.key, 'dispatchOrderDemand')"  :disabled="true">保存</a-button>
          <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'dispatchOrderDemand')">
          <a-button type="primary" style="margin-right: 10px" :disabled="true">取消</a-button>
          </a-popconfirm>
          </span>
          <span v-else>
          <a-button  @click="() => demandEdit(record.key, 'dispatchOrderDemand')" type="primary" style="margin-right: 10px" :disabled="true"> 编辑</a-button>
          </span>
          <a-button type="primary" v-if="record.disabledFlag==0" @click="disableDemand(record.demandId)" style="margin-right: 10px" :disabled="true">禁用</a-button>
          <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px" :disabled="true">启用</a-button>
          <a-button type="primary" @click="deleteDemand(record.demandId)" style="margin-right: 10px" :disabled="true">删除</a-button>
          </template>
          <template slot="demandContent" slot-scope="text, record, index">
          <div>
          <a-input :disabled="true"
          v-if="record.editable"
          style="margin: -5px 0"
          :value="text"
          @change="e => demandChange(e.target.value, record.key, 'dispatchOrderDemand')" />
          <template v-else>
          {{ text }}
          </template>
          </div>
          </template>
          </a-table>
          <template>
          <a-textarea v-model.trim="dispatchOrderDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px" />
          <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('dispatch_order_demand')" :disabled="true">提交</a-button>
          </template>
          <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 },wrapperCol: { span: 15 } }">
          <div class="clearfix">
          <a-upload :disabled="true"
          :action="uploadUrlb"
          list-type="picture-card"
          :file-list="fileList2"
          :headers="headers"
          @preview="handlePreview2"
          @change="handleChange2"
          >
          <div>
          <a-icon type="plus" />
          <div class="ant-upload-text">上传</div>
          </div>
          </a-upload>
          <a-modal :disabled="true" :visible="previewVisible2" :footer="null" @cancel="handleCancel2">
          <img alt="example" style="width: 100%" :src="previewImage2" />
          </a-modal>
          </div>
          <a-col :span="24" style="display: flex;justify-content: center;">
          <a-button type="primary" @click="picSubmit('dispatch_order_demand')" html-type="submit" :disabled="true">
          提交
          </a-button>
          </a-col>
          </a-form-item>
        </a-tab-pane>
        <a-tab-pane v-if="detailOther" tab="金额要求"  key="3">
          <a-table
          size="default"
          ref="table"
          :pagination="pagination"
          :columns="demandColumns"
          :dataSource="priceDemand">
          <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
          <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px" :disabled="true">配置</a-button>
          <span v-if="record.editable">
          <a-button type="primary" style="margin-right: 10px" @click="() => demandSubmit(record.key, 'priceDemand')" :disabled="true">保存</a-button>
          <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'priceDemand')">
          <a-button type="primary" style="margin-right: 10px" :disabled="true">取消</a-button>
          </a-popconfirm>
          </span>
          <span v-else>
          <a-button :disabled="true" @click="() => demandEdit(record.key, 'priceDemand')" type="primary" style="margin-right: 10px">编辑</a-button>
          </span>
          <a-button type="primary" v-if="record.disabledFlag==0" @click="disableDemand(record.demandId)" style="margin-right: 10px" :disabled="true">禁用</a-button>
          <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px" :disabled="true">启用</a-button>
          <a-button type="primary"  @click="deleteDemand(record.demandId)" style="margin-right: 10px" :disabled="true">删除</a-button>
          </template>
          <template slot="demandContent" slot-scope="text, record, index">
          <div>
          <a-input :disabled="true"
          v-if="record.editable"
          style="margin: -5px 0"
          :value="text"
          @change="e => demandChange(e.target.value, record.key, 'priceDemand')" />
          <template v-else>
          {{ text }}
          </template>
          </div>
          </template>
          </a-table>
          <template>
          <a-textarea v-model.trim="priceDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px" />
          <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('price_demand')" :disabled="true">提交</a-button>
          </template>
          <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 },wrapperCol: { span: 15 } }">
          <div class="clearfix">
          <a-upload :disabled="true"
          :action="uploadUrlb"
          list-type="picture-card"
          :file-list="fileList3"
          :headers="headers"
          @preview="handlePreview3"
          @change="handleChange3"
          >
          <div>
          <a-icon type="plus" />
          <div class="ant-upload-text">上传</div>
          </div>
          </a-upload>
          <a-modal  :disabled="true" :visible="previewVisible3" :footer="null" @cancel="handleCancel3">
          <img alt="example" style="width: 100%" :src="previewImage3" />
          </a-modal>
          </div>
          <a-col :span="24" style="display: flex;justify-content: center;">
          <a-button type="primary" @click="picSubmit('price_demand')" html-type="submit" :disabled="true">
          提交
          </a-button>
          </a-col>
          </a-form-item>
        </a-tab-pane>
        <a-tab-pane v-if="detailMaster" tab="师傅要求"  key="4">
          <a-table
          size="default"
          ref="table"
          :pagination="pagination"
          :columns="demandColumns"
          :dataSource="masterDemand">
          <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
          <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px" :disabled="true">配置</a-button>
          <span v-if="record.editable">
          <a-button type="primary" style="margin-right: 10px" @click="() => demandSubmit(record.key, 'masterDemand')"  :disabled="true">保存</a-button>
          <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'masterDemand')">
          <a-button type="primary" style="margin-right: 10px" :disabled="true">取消</a-button>
          </a-popconfirm>
          </span>
          <span v-else>
          <a-button :disabled="true" @click="() => demandEdit(record.key, 'masterDemand')" type="primary" style="margin-right: 10px">编辑</a-button>
          </span>
          <a-button type="primary" v-if="record.disabledFlag==0" @click="disableDemand(record.demandId)" style="margin-right: 10px" :disabled="true">禁用</a-button>
          <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px" :disabled="true">启用</a-button>
          <a-button type="primary"  @click="deleteDemand(record.demandId)" style="margin-right: 10px" :disabled="true">删除</a-button>
          </template>
          <template slot="demandContent" slot-scope="text, record, index">
          <div>
          <a-input :disabled="true"
          v-if="record.editable"
          style="margin: -5px 0"
          :value="text"
          @change="e => demandChange(e.target.value, record.key, 'masterDemand')" />
          <template v-else>
          {{ text }}
          </template>
          </div>
          </template>
          </a-table>
          <template>
          <a-textarea v-model.trim="masterDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px" />
          <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('master_demand')" :disabled="true">提交</a-button>
          </template>
          <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 },wrapperCol: { span: 15 } }">
          <div class="clearfix">
          <a-upload :disabled="true"
          :action="uploadUrlb"
          list-type="picture-card"
          :file-list="fileList4"
          :headers="headers"
          @preview="handlePreview4"
          @change="handleChange4"
          >
          <div>
          <a-icon type="plus" />
          <div class="ant-upload-text">上传</div>
          </div>
          </a-upload>
          <a-modal :disabled="true" :visible="previewVisible4" :footer="null" @cancel="handleCancel4">
          <img alt="example" style="width: 100%" :src="previewImage4" />
          </a-modal>
          </div>
          <a-col :span="24" style="display: flex;justify-content: center;">
          <a-button type="primary" @click="picSubmit('master_demand')" html-type="submit" :disabled="true">
          提交
          </a-button>
          </a-col>
          </a-form-item>
        </a-tab-pane>
        <a-tab-pane v-if="detailOther" tab="核销要求"  key="5">
          <a-table
          size="default"
          ref="table"
          :pagination="pagination"
          :columns="demandColumns"
          :dataSource="writeoffDemand">
          <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
          <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px" :disabled="true">配置</a-button>
          <span v-if="record.editable">
          <a-button type="primary" style="margin-right: 10px" @click="() => demandSubmit(record.key, 'writeoffDemand')"  :disabled="true">保存</a-button>
          <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'writeoffDemand')">
          <a-button type="primary" style="margin-right: 10px" :disabled="true">取消</a-button>
          </a-popconfirm>
          </span>
          <span v-else>
          <a-button :disabled="true" @click="() => demandEdit(record.key, 'writeoffDemand')" type="primary" style="margin-right: 10px">编辑</a-button>
          </span>
          <a-button type="primary" v-if="record.disabledFlag==0" @click="disableDemand(record.demandId)" style="margin-right: 10px" :disabled="true">禁用</a-button>
          <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px" :disabled="true"启用</a-button>
          <a-button type="primary" @click="deleteDemand(record.demandId)" style="margin-right: 10px" :disabled="true">删除</a-button>
          </template>
          <template slot="demandContent" slot-scope="text, record, index">
          <div>
          <a-input  :disabled="true"
          v-if="record.editable"
          style="margin: -5px 0"
          :value="text"
          @change="e => demandChange(e.target.value, record.key, 'writeoffDemand')" />
          <template v-else>
          {{ text }}
          </template>
          </div>
          </template>
          </a-table>
          <template>
          <a-textarea v-model.trim="writeoffDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px" />
          <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('writeoff_demand')" :disabled="true">提交</a-button>
          </template>
          <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 },wrapperCol: { span: 15 } }">
          <div class="clearfix">
          <a-upload :disabled="true"
          :action="uploadUrlb"
          list-type="picture-card"
          :file-list="fileList5"
          :headers="headers"
          @preview="handlePreview5"
          @change="handleChange5"
          >
          <div>
          <a-icon type="plus" />
          <div class="ant-upload-text">上传</div>
          </div>
          </a-upload>
          <a-modal :disabled="true" :visible="previewVisible5" :footer="null" @cancel="handleCancel5">
          <img alt="example" style="width: 100%" :src="previewImage5" />
          </a-modal>
          </div>
          <a-col :span="24" style="display: flex;justify-content: center;">
          <a-button type="primary" @click="picSubmit('writeoff_demand')" html-type="submit" :disabled="true">
          提交
          </a-button>
          </a-col>
          </a-form-item>
        </a-tab-pane>
      </a-tabs>
      <enterprise-details-modal ref="modal" @ok="handleOk"/>
      <enterprise-demand-config ref="demand" @ok="handleOk"/>
    </div>
  </a-modal>
    </div>


     <div v-else>
    <a-modal v-model="requirementsEnterpriseible" footer="'" title="企业要求" width="85%" >
      <div style="margin-top: 40px;" :class="[!detailEdit ? 'disEvents':'disEvents2']">
        <a-tabs type="card" @change="callbackSet">
          <a-tab-pane v-if="detailOther" tab="下单要求" key="1">
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="demandColumns"
              :dataSource="createOrderDemand">
              <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
                <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px">配置</a-button>
                <span v-if="record.editable">
            <!--{{record.editable}}-->
          <a-button type="primary" style="margin-right: 10px" @click="() => demandSubmit(record.key, 'createOrderDemand')" >保存</a-button>
          <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'createOrderDemand')">
          <a-button type="primary" style="margin-right: 10px">取消</a-button>
          </a-popconfirm>
          </span>
                <span v-else>
            <!--{{record.editable}}-->
          <a-button :disabled="editingKey !== ''" @click="() => demandEdit(record.key, 'createOrderDemand')" type="primary" style="margin-right: 10px">编辑</a-button>
          </span>
                <a-button type="primary" v-if="record.disabledFlag==0" @click="disableDemand(record.demandId)" style="margin-right: 10px">禁用</a-button>
                <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px">启用</a-button>
                <a-button type="primary"  @click="deleteDemand(record.demandId)" style="margin-right: 10px">删除</a-button>
              </template>
              <template slot="demandContent" slot-scope="text, record, index">
                <div>
                  <a-input
                    v-if="record.editable"
                    style="margin: -5px 0"
                    :value="text"
                    @change="e => demandChange(e.target.value, record.key, 'createOrderDemand')" />
                  <template v-else>
                    {{ text }}
                  </template>
                </div>
              </template>
            </a-table>
            <template>
              <a-textarea v-model.trim="createOrderDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px" />
              <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('create_order_demand')">提交</a-button>
            </template>
            <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 },wrapperCol: { span: 15 } }">
              <div class="clearfix">
                <a-upload
                  :action="uploadUrlb"
                  list-type="picture-card"
                  :file-list="fileList"
                  :headers="headers"
                  @preview="handlePreview"
                  @change="handleChange"
                >
                  <div>
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                  <img alt="example" style="width: 100%" :src="previewImage" />
                </a-modal>
              </div>
              <a-col :span="24" style="display: flex;justify-content: center;">
                <a-button type="primary" @click="picSubmit('create_order_demand')" html-type="submit">
                  提交
                </a-button>
              </a-col>
            </a-form-item>
          </a-tab-pane>
          <a-tab-pane v-if="detailOther" tab="派单要求"  key="2">
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="demandColumns"
              :dataSource="dispatchOrderDemand">
              <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
                <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px">配置</a-button>
                <span v-if="record.editable">
          <a-button type="primary" style="margin-right: 10px" @click="() => demandSubmit(record.key, 'dispatchOrderDemand')" >保存</a-button>
          <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'dispatchOrderDemand')">
          <a-button type="primary" style="margin-right: 10px">取消</a-button>
          </a-popconfirm>
          </span>
                <span v-else>
          <a-button :disabled="editingKey !== ''" @click="() => demandEdit(record.key, 'dispatchOrderDemand')" type="primary" style="margin-right: 10px">编辑</a-button>
          </span>
                <a-button type="primary" v-if="record.disabledFlag==0" @click="disableDemand(record.demandId)" style="margin-right: 10px">禁用</a-button>
                <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px">启用</a-button>
                <a-button type="primary" @click="deleteDemand(record.demandId)" style="margin-right: 10px">删除</a-button>
              </template>
              <template slot="demandContent" slot-scope="text, record, index">
                <div>
                  <a-input
                    v-if="record.editable"
                    style="margin: -5px 0"
                    :value="text"
                    @change="e => demandChange(e.target.value, record.key, 'dispatchOrderDemand')" />
                  <template v-else>
                    {{ text }}
                  </template>
                </div>
              </template>
            </a-table>
            <template>
              <a-textarea v-model.trim="dispatchOrderDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px" />
              <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('dispatch_order_demand')">提交</a-button>
            </template>
            <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 },wrapperCol: { span: 15 } }">
              <div class="clearfix">
                <a-upload
                  :action="uploadUrlb"
                  list-type="picture-card"
                  :file-list="fileList2"
                  :headers="headers"
                  @preview="handlePreview2"
                  @change="handleChange2"
                >
                  <div>
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
                <a-modal :visible="previewVisible2" :footer="null" @cancel="handleCancel2">
                  <img alt="example" style="width: 100%" :src="previewImage2" />
                </a-modal>
              </div>
              <a-col :span="24" style="display: flex;justify-content: center;">
                <a-button type="primary" @click="picSubmit('dispatch_order_demand')" html-type="submit">
                  提交
                </a-button>
              </a-col>
            </a-form-item>
          </a-tab-pane>
          <a-tab-pane v-if="detailOther" tab="金额要求"  key="3">
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="demandColumns"
              :dataSource="priceDemand">
              <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
                <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px">配置</a-button>
                <span v-if="record.editable">
          <a-button type="primary" style="margin-right: 10px" @click="() => demandSubmit(record.key, 'priceDemand')" >保存</a-button>
          <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'priceDemand')">
          <a-button type="primary" style="margin-right: 10px">取消</a-button>
          </a-popconfirm>
          </span>
                <span v-else>
          <a-button :disabled="editingKey !== ''" @click="() => demandEdit(record.key, 'priceDemand')" type="primary" style="margin-right: 10px">编辑</a-button>
          </span>
                <a-button type="primary" v-if="record.disabledFlag==0" @click="disableDemand(record.demandId)" style="margin-right: 10px">禁用</a-button>
                <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px">启用</a-button>
                <a-button type="primary"  @click="deleteDemand(record.demandId)" style="margin-right: 10px">删除</a-button>
              </template>
              <template slot="demandContent" slot-scope="text, record, index">
                <div>
                  <a-input
                    v-if="record.editable"
                    style="margin: -5px 0"
                    :value="text"
                    @change="e => demandChange(e.target.value, record.key, 'priceDemand')" />
                  <template v-else>
                    {{ text }}
                  </template>
                </div>
              </template>
            </a-table>
            <template>
              <a-textarea v-model.trim="priceDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px" />
              <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('price_demand')">提交</a-button>
            </template>
            <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 },wrapperCol: { span: 15 } }">
              <div class="clearfix">
                <a-upload
                  :action="uploadUrlb"
                  list-type="picture-card"
                  :file-list="fileList3"
                  :headers="headers"
                  @preview="handlePreview3"
                  @change="handleChange3"
                >
                  <div>
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
                <a-modal :visible="previewVisible3" :footer="null" @cancel="handleCancel3">
                  <img alt="example" style="width: 100%" :src="previewImage3" />
                </a-modal>
              </div>
              <a-col :span="24" style="display: flex;justify-content: center;">
                <a-button type="primary" @click="picSubmit('price_demand')" html-type="submit">
                  提交
                </a-button>
              </a-col>
            </a-form-item>
          </a-tab-pane>
          <a-tab-pane v-if="detailMaster" tab="师傅要求"  key="4">
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="demandColumns"
              :dataSource="masterDemand">
              <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
                <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px">配置</a-button>
                <span v-if="record.editable">
          <a-button type="primary" style="margin-right: 10px" @click="() => demandSubmit(record.key, 'masterDemand')" >保存</a-button>
          <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'masterDemand')">
          <a-button type="primary" style="margin-right: 10px">取消</a-button>
          </a-popconfirm>
          </span>
                <span v-else>
          <a-button :disabled="editingKey !== ''" @click="() => demandEdit(record.key, 'masterDemand')" type="primary" style="margin-right: 10px">编辑</a-button>
          </span>
                <a-button type="primary" v-if="record.disabledFlag==0" @click="disableDemand(record.demandId)" style="margin-right: 10px">禁用</a-button>
                <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px">启用</a-button>
                <a-button type="primary"  @click="deleteDemand(record.demandId)" style="margin-right: 10px">删除</a-button>
              </template>
              <template slot="demandContent" slot-scope="text, record, index">
                <div>
                  <a-input
                    v-if="record.editable"
                    style="margin: -5px 0"
                    :value="text"
                    @change="e => demandChange(e.target.value, record.key, 'masterDemand')" />
                  <template v-else>
                    {{ text }}
                  </template>
                </div>
              </template>
            </a-table>
            <template>
              <a-textarea v-model.trim="masterDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px" />
              <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('master_demand')">提交</a-button>
            </template>
            <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 },wrapperCol: { span: 15 } }">
              <div class="clearfix">
                <a-upload
                  :action="uploadUrlb"
                  list-type="picture-card"
                  :file-list="fileList4"
                  :headers="headers"
                  @preview="handlePreview4"
                  @change="handleChange4"
                >
                  <div>
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
                <a-modal :visible="previewVisible4" :footer="null" @cancel="handleCancel4">
                  <img alt="example" style="width: 100%" :src="previewImage4" />
                </a-modal>
              </div>
              <a-col :span="24" style="display: flex;justify-content: center;">
                <a-button type="primary" @click="picSubmit('master_demand')" html-type="submit">
                  提交
                </a-button>
              </a-col>
            </a-form-item>
          </a-tab-pane>
          <a-tab-pane v-if="detailOther" tab="核销要求"  key="5">
            <a-table
              size="default"
              ref="table"
              :pagination="pagination"
              :columns="demandColumns"
              :dataSource="writeoffDemand">
              <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
                <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px">配置</a-button>
                <span v-if="record.editable">
          <a-button type="primary" style="margin-right: 10px" @click="() => demandSubmit(record.key, 'writeoffDemand')" >保存</a-button>
          <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'writeoffDemand')">
          <a-button type="primary" style="margin-right: 10px">取消</a-button>
          </a-popconfirm>
          </span>
                <span v-else>
          <a-button :disabled="editingKey !== ''" @click="() => demandEdit(record.key, 'writeoffDemand')" type="primary" style="margin-right: 10px">编辑</a-button>
          </span>
                <a-button type="primary" v-if="record.disabledFlag==0" @click="disableDemand(record.demandId)" style="margin-right: 10px">禁用</a-button>
                <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px">启用</a-button>
                <a-button type="primary" @click="deleteDemand(record.demandId)" style="margin-right: 10px">删除</a-button>
              </template>
              <template slot="demandContent" slot-scope="text, record, index">
                <div>
                  <a-input
                    v-if="record.editable"
                    style="margin: -5px 0"
                    :value="text"
                    @change="e => demandChange(e.target.value, record.key, 'writeoffDemand')" />
                  <template v-else>
                    {{ text }}
                  </template>
                </div>
              </template>
            </a-table>
            <template>
              <a-textarea v-model.trim="writeoffDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px" />
              <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('writeoff_demand')">提交</a-button>
            </template>
            <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 },wrapperCol: { span: 15 } }">
              <div class="clearfix">
                <a-upload
                  :action="uploadUrlb"
                  list-type="picture-card"
                  :file-list="fileList5"
                  :headers="headers"
                  @preview="handlePreview5"
                  @change="handleChange5"
                >
                  <div>
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
                <a-modal :visible="previewVisible5" :footer="null" @cancel="handleCancel5">
                  <img alt="example" style="width: 100%" :src="previewImage5" />
                </a-modal>
              </div>
              <a-col :span="24" style="display: flex;justify-content: center;">
                <a-button type="primary" @click="picSubmit('writeoff_demand')" html-type="submit">
                  提交
                </a-button>
              </a-col>
            </a-form-item>
          </a-tab-pane>
        </a-tabs>
        <enterprise-details-modal ref="modal" @ok="handleOk"/>
        <enterprise-demand-config ref="demand" @ok="handleOk"/>
      </div>
    </a-modal>
  </div>

</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { STable } from '@/components'
import { checkPermission } from '@/utils/permissions'
import {
  getEnterpriseDetail,
  getselectAllProvince,
  customInfoGet,
  customInfoSave,
  getselectCityName,
  getselectAreaName,
  updateEnterprise,
} from '@/api/enterprise/enterprise'
import EnterpriseDetailsModal from '@/views/enterprise/modules/EnterpriseDetailsModal'
import EnterpriseDemandConfig from '@/views/enterprise/modules/EnterpriseDemandConfig'
import {
  getGuaranteeList,
  saveEnterpriseGuarantee,
  getDemandList,
  updateDemand,
  addDemand,
  disableDemand,
  enableDemand,
  delDemand,
  demandPicAdd,
  demandPicList,
} from '@/api/enterprise/guarantee'
export default {
  name: 'requirementsEnterpriseModel',
  components: {
    EnterpriseDetailsModal,
    EnterpriseDemandConfig,
    STable,
    // PDFmodel,
  },
  data() {
    return {
      enterpriseIdss: '',
      createOrderDemandContent: '',
      dispatchOrderDemandContent: '',
      masterDemandContent: '',
      priceDemandContent: '',
      writeoffDemandContent: '',
      requirementsEnterpriseible: false,
      visible: false,
      enterpriseId: '',
      pagination: false,
      previewVisible: false,
      previewVisible2: false,
      previewVisible3: false,
      previewVisible4: false,
      previewVisible5: false,
      previewImage: '',
      previewImage2: '',
      previewImage3: '',
      previewImage4: '',
      previewImage5: '',
      editingKey: '',
      isShow: 0,
      demandColumns: [
        {
          title: '操作',
          width: '30%',
          dataIndex: 'demandId',
          scopedSlots: { customRender: 'demandOperate' },
        },
        {
          title: '要求内容',
          width: '45%',
          ellipsis: true,
          dataIndex: 'demandContent',
          scopedSlots: { customRender: 'demandContent' },
        },

        {
          title: '操作时间',
          width: '15%',
          dataIndex: 'updateTime',
        },
        {
          title: '操作人',
          width: '10%',
          dataIndex: 'updateBy',
        },
      ],
      priceDemand: [],
      createOrderDemand: [],
      dispatchOrderDemand: [],
      masterDemand: [],
      writeoffDemand: [],
      cacheCreateOrderDemand: [],
      cacheDispatchOrderDemand: [],
      cacheMasterDemand: [],
      cachePriceDemand: [],
      cacheWriteoffDemand: [],
      filePaths: [],
      filePaths2: [],
      filePaths3: [],
      filePaths4: [],
      filePaths5: [],
      picData: [],
      uploadUrlb2: '',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      fileList: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      uploadUrlb: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=enterprise',
      detailOther: checkPermission('order:list:detail:enterpriseDemand:other'),
      detailMaster: checkPermission('order:list:detail:enterpriseDemand:master'),
      detailEdit: checkPermission('order:list:detail:enterpriseDemand:edit'),
    }
  },
  created() {},
  methods: {
    // enterpriseId
    showrequirement(id, A) {
      // this.form.resetFields()
      this.createOrderDemandContent = ''
      this.dispatchOrderDemandContent = ''
      this.masterDemandContent = ''
      this.priceDemandContent = ''
      this.writeoffDemandContent = ''
      this.enterpriseId = id

      this.enterpriseIdss = A ? A : ''
      this.requirementsEnterpriseible = true
      this.loadDemandList(this.enterpriseId)

      demandPicList({ enterpriseId: this.enterpriseId }).then((res) => {
        if (res.code === 0) {
          this.fileList = []
          this.fileList2 = []
          this.fileList3 = []
          this.fileList4 = []
          this.fileList5 = []
          let that = this
          if (res.data.create_order_demand !== undefined && res.data.create_order_demand !== null) {
            res.data.create_order_demand.forEach((pic) => {
              this.getImgToBase64(
                process.env.VUE_APP_API_BASE_URL +
                  '/dfs/download?fileName=' +
                  pic.picPath +
                  '&token=' +
                  Vue.ls.get(ACCESS_TOKEN),
                function (data) {
                  that.fileList.push({
                    uid: pic.picId,
                    thumbUrl: data,
                    url: pic.picPath,
                  })
                }
              )
            })
          }
          if (res.data.dispatch_order_demand !== undefined && res.data.dispatch_order_demand !== null) {
            res.data.dispatch_order_demand.forEach((pic) => {
              this.getImgToBase64(
                process.env.VUE_APP_API_BASE_URL +
                  '/dfs/download?fileName=' +
                  pic.picPath +
                  '&token=' +
                  Vue.ls.get(ACCESS_TOKEN),
                function (data) {
                  that.fileList2.push({
                    uid: pic.picId,
                    thumbUrl: data,
                    url: pic.picPath,
                  })
                }
              )
            })
          }
          if (res.data.price_demand !== undefined && res.data.price_demand !== null) {
            res.data.price_demand.forEach((pic) => {
              this.getImgToBase64(
                process.env.VUE_APP_API_BASE_URL +
                  '/dfs/download?fileName=' +
                  pic.picPath +
                  '&token=' +
                  Vue.ls.get(ACCESS_TOKEN),
                function (data) {
                  that.fileList3.push({
                    uid: pic.picId,
                    thumbUrl: data,
                    url: pic.picPath,
                  })
                }
              )
            })
          }
          if (res.data.master_demand !== undefined && res.data.master_demand !== null) {
            res.data.master_demand.forEach((pic) => {
              this.getImgToBase64(
                process.env.VUE_APP_API_BASE_URL +
                  '/dfs/download?fileName=' +
                  pic.picPath +
                  '&token=' +
                  Vue.ls.get(ACCESS_TOKEN),
                function (data) {
                  that.fileList4.push({
                    uid: pic.picId,
                    thumbUrl: data,
                    url: pic.picPath,
                  })
                }
              )
            })
          }
          if (res.data.writeoff_demand !== undefined && res.data.writeoff_demand !== null) {
            res.data.writeoff_demand.forEach((pic) => {
              this.getImgToBase64(
                process.env.VUE_APP_API_BASE_URL +
                  '/dfs/download?fileName=' +
                  pic.picPath +
                  '&token=' +
                  Vue.ls.get(ACCESS_TOKEN),
                function (data) {
                  that.fileList5.push({
                    uid: pic.picId,
                    thumbUrl: data,
                    url: pic.picPath,
                  })
                }
              )
            })
          }
        }
      })
    },

    handleCancel() {
      this.previewVisible = false
    },
    handlePreview(file) {
      this.previewImage =
        process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      this.previewVisible = true
    },
    handChange(e) {
      console.log(e)
      if (e == 1) {
        this.isShow = 1
      } else {
        this.isShow = 0
      }
    },
    handleChange({ fileList }) {
      this.fileList = fileList
      if (fileList.length === 0) {
        this.filePaths = []
      } else {
        this.filePaths = []
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response !== undefined) {
            this.filePaths.push(fileList[i].response.url)
          }
          if (fileList[i].url !== undefined) {
            this.filePaths.push(fileList[i].url)
          }
        }
      }
    },
    handleCancel2() {
      this.previewVisible2 = false
    },
    handlePreview2(file) {
      this.previewImage2 =
        process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      this.previewVisible2 = true
    },
    handleChange2({ fileList }) {
      this.fileList2 = fileList
      if (fileList.length === 0) {
        this.filePaths2 = []
      } else {
        this.filePaths2 = []
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response !== undefined) {
            this.filePaths2.push(fileList[i].response.url)
          }
          if (fileList[i].url !== undefined) {
            this.filePaths2.push(fileList[i].url)
          }
        }
      }
    },
    handleCancel3() {
      this.previewVisible3 = false
    },
    handlePreview3(file) {
      this.previewImage3 =
        process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      this.previewVisible3 = true
    },
    handleChange3({ fileList }) {
      this.fileList3 = fileList
      if (fileList.length === 0) {
        this.filePaths3 = []
      } else {
        this.filePaths3 = []
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response !== undefined) {
            this.filePaths3.push(fileList[i].response.url)
          }
          if (fileList[i].url !== undefined) {
            this.filePaths3.push(fileList[i].url)
          }
        }
      }
    },
    handleCancel4() {
      this.previewVisible4 = false
    },
    handlePreview4(file) {
      this.previewImage4 =
        process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      this.previewVisible4 = true
    },
    handleChange4({ fileList }) {
      this.fileList4 = fileList
      if (fileList.length === 0) {
        this.filePaths4 = []
      } else {
        this.filePaths4 = []
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response !== undefined) {
            this.filePaths4.push(fileList[i].response.url)
          }
          if (fileList[i].url !== undefined) {
            this.filePaths4.push(fileList[i].url)
          }
        }
      }
    },
    handleCancel5() {
      this.previewVisible5 = false
    },
    handlePreview5(file) {
      this.previewImage5 =
        process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      this.previewVisible5 = true
    },
    handleChange5({ fileList }) {
      this.fileList5 = fileList
      if (fileList.length === 0) {
        this.filePaths5 = []
      } else {
        this.filePaths5 = []
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response !== undefined) {
            this.filePaths5.push(fileList[i].response.url)
          }
          if (fileList[i].url !== undefined) {
            this.filePaths5.push(fileList[i].url)
          }
        }
      }
    },
    getImgToBase64(url, callback) {
      //将图片转换为Base64
      var canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d'),
        img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        var dataURL = canvas.toDataURL('image/png')
        callback(dataURL)
        canvas = null
      }
      img.src = url
    },
    callbackSet(key) {
      // console.log(key)
    },
    configDemand(id) {
      this.$refs.demand.config(id)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    addGuarantee(data) {
      data.push({ guaranteeId: '' })
    },
    picSubmit(value) {
      this.picData = []
      if (value === 'create_order_demand') {
        this.picData = this.filePaths
      }
      if (value === 'dispatch_order_demand') {
        this.picData = this.filePaths2
      }
      if (value === 'price_demand') {
        this.picData = this.filePaths3
      }
      if (value === 'master_demand') {
        this.picData = this.filePaths4
      }
      if (value === 'writeoff_demand') {
        this.picData = this.filePaths5
      }
      demandPicAdd({ enterpriseId: this.enterpriseId, picType: value, filePaths: this.picData }).then((res) => {
        if (res.code === 0) {
          this.$message.success('保存成功')
          this.requirementsEnterpriseible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    delGuarantee(data, record) {
      let index = data.indexOf(record)
      if (index !== -1) {
        data.splice(index, 1)
      }
    },
    demandChange(value, key, name) {
      let newData = []
      if (name === 'createOrderDemand') {
        newData = [...this.createOrderDemand]
      } else if (name === 'dispatchOrderDemand') {
        newData = [...this.dispatchOrderDemand]
      } else if (name === 'masterDemand') {
        newData = [...this.masterDemand]
      } else if (name === 'priceDemand') {
        newData = [...this.priceDemand]
      } else if (name === 'writeoffDemand') {
        newData = [...this.writeoffDemand]
      }
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        target['demandContent'] = value
        if (name === 'createOrderDemand') {
          this.createOrderDemand = newData
        } else if (name === 'dispatchOrderDemand') {
          this.dispatchOrderDemand = newData
        } else if (name === 'masterDemand') {
          this.masterDemand = newData
        } else if (name === 'priceDemand') {
          this.priceDemand = newData
        } else if (name === 'writeoffDemand') {
          this.writeoffDemand = newData
        }
      }
    },
    
    demandCancel(key, name) {
      let newData = []
      let cacheData = []
      if (name === 'createOrderDemand') {
        newData = [...this.createOrderDemand]
        cacheData = this.cacheCreateOrderDemand
      } else if (name === 'dispatchOrderDemand') {
        newData = [...this.dispatchOrderDemand]
        cacheData = this.cacheDispatchOrderDemand
      } else if (name === 'masterDemand') {
        newData = [...this.masterDemand]
        cacheData = this.cacheMasterDemand
      } else if (name === 'priceDemand') {
        newData = [...this.priceDemand]
        cacheData = this.cachePriceDemand
      } else if (name === 'writeoffDemand') {
        newData = [...this.writeoffDemand]
        cacheData = this.cacheWriteoffDemand
      }
      const target = newData.filter((item) => key === item.key)[0]
      this.editingKey = ''
      if (target) {
        Object.assign(target, cacheData.filter((item) => key === item.key)[0])
        delete target.editable
        if (name === 'createOrderDemand') {
          this.createOrderDemand = newData
        } else if (name === 'dispatchOrderDemand') {
          this.dispatchOrderDemand = newData
        } else if (name === 'masterDemand') {
          this.masterDemand = newData
        } else if (name === 'priceDemand') {
          this.priceDemand = newData
        } else if (name === 'writeoffDemand') {
          this.writeoffDemand = newData
        }
      }
    },
    demandSubmit(key, name) {
      let newData = []
      if (name === 'createOrderDemand') {
        newData = [...this.createOrderDemand]
      } else if (name === 'dispatchOrderDemand') {
        newData = [...this.dispatchOrderDemand]
      } else if (name === 'masterDemand') {
        newData = [...this.masterDemand]
      } else if (name === 'priceDemand') {
        newData = [...this.priceDemand]
      } else if (name === 'writeoffDemand') {
        newData = [...this.writeoffDemand]
      }
      const target = newData.filter((item) => key === item.key)[0]
      if (target.demandContent === '') {
        this.$message.error('要求不能为空！')
        return
      }
      this.editingKey = ''
      if (target) {
        delete target.editable
        if (name === 'createOrderDemand') {
          this.createOrderDemand = newData
        } else if (name === 'dispatchOrderDemand') {
          this.dispatchOrderDemand = newData
        } else if (name === 'masterDemand') {
          this.masterDemand = newData
        } else if (name === 'priceDemand') {
          this.priceDemand = newData
        } else if (name === 'writeoffDemand') {
          this.writeoffDemand = newData
        }

        updateDemand({ demandId: target.demandId, demandContent: target.demandContent }).then((res) => {
          if (res.code === 0) {
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    demandEdit(key, name) {
      let newData = []
      if (name === 'createOrderDemand') {
        newData = [...this.createOrderDemand]
      } else if (name === 'dispatchOrderDemand') {
        newData = [...this.dispatchOrderDemand]
      } else if (name === 'masterDemand') {
        newData = [...this.masterDemand]
      } else if (name === 'priceDemand') {
        newData = [...this.priceDemand]
      } else if (name === 'writeoffDemand') {
        newData = [...this.writeoffDemand]
      }
      const target = newData.filter((item) => key === item.key)[0]
      this.editingKey = key
      if (target) {
        target.editable = true
        if (name === 'createOrderDemand') {
          this.createOrderDemand = newData
        } else if (name === 'dispatchOrderDemand') {
          this.dispatchOrderDemand = newData
        } else if (name === 'masterDemand') {
          this.masterDemand = newData
        } else if (name === 'priceDemand') {
          this.priceDemand = newData
        } else if (name === 'writeoffDemand') {
          this.writeoffDemand = newData
        }
      }
    },
    demandContentSubmit(name) {
      let demandData = {}
      demandData.enterpriseId = this.enterpriseId
      if (name === 'create_order_demand') {
        demandData.demandContent = this.createOrderDemandContent
      }
      if (name === 'dispatch_order_demand') {
        demandData.demandContent = this.dispatchOrderDemandContent
      }
      if (name === 'master_demand') {
        demandData.demandContent = this.masterDemandContent
      }
      if (name === 'price_demand') {
        demandData.demandContent = this.priceDemandContent
      }
      if (name === 'writeoff_demand') {
        demandData.demandContent = this.writeoffDemandContent
      }
      demandData.demandType = name

      if (demandData.demandContent === '') {
        this.$message.error('要求不能为空！')
        return
      }

      addDemand(demandData).then((res) => {
        if (res.code === 0) {
          this.$message.success('保存成功')
          this.createOrderDemandContent = ''
          this.dispatchOrderDemandContent = ''
          this.masterDemandContent = ''
          this.priceDemandContent = ''
          this.writeoffDemandContent = ''
          this.loadDemandList(this.enterpriseId)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    disableDemand(id) {
      disableDemand({ demandId: id }).then((res) => {
        if (res.code === 0) {
          this.$message.success('禁用成功')
          this.loadDemandList(this.enterpriseId)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    enableDemand(id) {
      enableDemand({ demandId: id }).then((res) => {
        if (res.code === 0) {
          this.$message.success('启用成功')
          this.loadDemandList(this.enterpriseId)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    deleteDemand(id) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          delDemand({ demandId: id }).then((res) => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.loadDemandList(that.enterpriseId)
            } else {
              that.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          console.log('Cancel')
        },
      })
      // delDemand({ 'demandId': id }).then(res => {
      //   if (res.code === 0) {
      //     this.$message.success('删除成功')
      //     this.loadDemandList(this.enterpriseId)
      //   } else {
      //     this.$message.error(res.msg)
      //   }
      // })
    },
    loadDemandList(enterpriseId) {
      this.$emit('ok')
      getDemandList({ enterpriseId: enterpriseId }).then((res) => {
        if (res.code === 0) {
          this.createOrderDemand = res.data.demandList.create_order_demand
          if (this.createOrderDemand !== undefined) {
            this.cacheCreateOrderDemand = this.createOrderDemand.map((item) => ({ ...item }))
            for (let i = 0; i < this.createOrderDemand.length; i++) {
              this.createOrderDemand[i].key = i
              this.cacheCreateOrderDemand[i].key = i
            }
          }
          this.dispatchOrderDemand = res.data.demandList.dispatch_order_demand
          if (this.dispatchOrderDemand !== undefined) {
            this.cacheDispatchOrderDemand = this.dispatchOrderDemand.map((item) => ({ ...item }))
            for (let i = 0; i < this.dispatchOrderDemand.length; i++) {
              this.dispatchOrderDemand[i].key = i
              this.cacheDispatchOrderDemand[i].key = i
            }
          }
          this.masterDemand = res.data.demandList.master_demand
          if (this.masterDemand !== undefined) {
            this.cacheMasterDemand = this.masterDemand.map((item) => ({ ...item }))
            for (let i = 0; i < this.masterDemand.length; i++) {
              this.masterDemand[i].key = i
              this.cacheMasterDemand[i].key = i
            }
          }
          this.priceDemand = res.data.demandList.price_demand
          if (this.priceDemand !== undefined) {
            this.cachePriceDemand = this.priceDemand.map((item) => ({ ...item }))
            for (let i = 0; i < this.priceDemand.length; i++) {
              this.priceDemand[i].key = i
              this.cachePriceDemand[i].key = i
            }
          }
          this.writeoffDemand = res.data.demandList.writeoff_demand
          if (this.writeoffDemand !== undefined) {
            this.cacheWriteoffDemand = this.writeoffDemand.map((item) => ({ ...item }))
            for (let i = 0; i < this.writeoffDemand.length; i++) {
              this.writeoffDemand[i].key = i
              this.cacheWriteoffDemand[i].key = i
            }
          }
          // console.log(res.data)
        }
      })
    },
  },
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td:first-child {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px 16px !important;
}
.disEvents {
  pointer-events: none;
}
.disEvents2 {
}
</style>